import { render, staticRenderFns } from "./IdentificationIcon.vue?vue&type=template&id=6a6b5ef1&"
import script from "./IdentificationIcon.vue?vue&type=script&lang=js&"
export * from "./IdentificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports